/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Sync_OkInputs */

const cs_projects_sync_ok = /** @type {(inputs: Projects_Sync_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt synchronizován na Sreality`)
};

const en_projects_sync_ok = /** @type {(inputs: Projects_Sync_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project synced to Sreality`)
};

/**
* | output |
* | --- |
* | "Project synced to Sreality" |
*
* @param {Projects_Sync_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_sync_ok = /** @type {((inputs?: Projects_Sync_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Sync_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_sync_ok(inputs)
	return cs_projects_sync_ok(inputs)
});